<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({ name: "UiStepsInput" });
</script>
<template>
    <div class="ui-steps-input" v-bind="binds.container">
        <div class="ui-steps-container" :style="style" :class="{ 'ui-active': currentPage == 'start' }">
            <input class="ui-form-control ui-steps-control" v-model="modelValue.start" v-bind="binds.input.start" v-on="ons.start" />
            <input class="ui-form-control ui-steps-number" v-model="modelValue['start-steps']" v-bind="binds.number" v-on="ons.start" />
        </div>
        <div class="ui-steps-rect" v-bind="binds.rect"></div>
        <div class="ui-steps-container" :style="style" :class="{ 'ui-active': currentPage == 'end' }">
            <input class="ui-form-control ui-steps-control" v-model="modelValue.end" v-bind="binds.input.end" v-on="ons.end" />
            <input class="ui-form-control ui-steps-number" v-model="modelValue['end-steps']" v-bind="binds.number" v-on="ons.end" />
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件属性
import { UiStepsInputPropsOption, UiStepsInputEmits } from "./index";
import { useComposable } from "./src/composable";

//* 注册组件属性
const define = defineProps(UiStepsInputPropsOption);
const emits = defineEmits(UiStepsInputEmits);

//* 组合函数
const { ons, refs, binds, computeds } = useComposable(define, emits);
const { currentPage } = refs;
const { style } = computeds;

//* 注册化组件配置
;
</script>
